import {useLoad, useUtilInformation} from 'components/hooks';
import {stage} from 'constants/url';

function useLoadStage(consult: boolean) {
  let {cwid, role} = useUtilInformation();
  if (consult) {
    role = 'consult';
  }
  return useLoad(stage, ['iD_Instance', 'iD_Course'], {
    role: role,
    cwid: cwid,
  });
}
export default useLoadStage;
